// 请求接口的方式
export const REQUEST_METHOD_GET = 'get';
export const REQUEST_METHOD_POST = 'post';

// export const HOME_PAGE_INFO_V2_RES = {
//     Result: 200,
//     ResultMessage: '成功',
//     CodeMsg: null,
//     Content: {
//         isOldCustomer: true,
//         redirectUrl: null,
//         scoreInfo: {
//             totalScore: 300,
//             differenceOfNextLockScore: 60
//         },
//         introBenefit: null,
//         payBenefit: {
//             score: '',
//             discount: '8折',
//             svip: {
//                 title: '尊享券包',
//                 desc: '',
//                 price: 18800
//             },
//             couponPackage: [
//                 {
//                     title: '尊享券包',
//                     desc: '',
//                     couponNum: 6,
//                     price: 18800
//                 }
//             ]
//         },
//         lifeBenefit: []
//     }
// };

// export const BUBBLE_SCORE_LIST_RES = {
//     Result: 200,
//     ResultMessage: '成功',
//     CodeMsg: null,
//     Content: {
//         timestamp: 131000000000,
//         bubbleScoreList: [
//             {
//                 id: 1212,
//                 taskId: 201,
//                 score: 5,
//                 title: '手机充值',
//                 bubbleType: 0,
//                 bubbleIcon: '/xxxx'
//             },
//             {
//                 id: 1212,
//                 taskId: 202,
//                 score: 10,
//                 title: '信用卡还款',
//                 bubbleType: 0,
//                 bubbleIcon: '/xxxx'
//             },
//             {
//                 id: 1212,
//                 taskId: 203,
//                 score: 10,
//                 title: '信用卡还款',
//                 bubbleType: 0,
//                 bubbleIcon: '/xxxx'
//             },
//             {
//                 id: 1212,
//                 taskId: 204,
//                 score: 10,
//                 title: '信用卡还款',
//                 bubbleType: 0,
//                 bubbleIcon: '/xxxx'
//             },
//             {
//                 id: 1212,
//                 taskId: 205,
//                 score: 10,
//                 title: '信用卡还款',
//                 bubbleType: 0,
//                 bubbleIcon: '/xxxx'
//             }
//         ]
//     }
// };
